export default __webpack_public_path__ + "static/media/FemaleBanner.3b76e3ef.svg";